import { Box, Table, Text } from '@mantine/core'

import { type ITag } from '../../tag.types'
import TagsTableRow from '../tagsTableRow/TagsTableRow.component'
import styles from './tags-table.module.scss'

interface TagsListProps {
  tags: ITag[]
  isLoading: boolean
  resetPaginate: () => void
}

const TagsListTable = ({ tags, isLoading, resetPaginate }: TagsListProps) => {
  if (isLoading) {
    return <Text>Loading...</Text>
  }

  return (
    <Box>
      <Table
        striped
        highlightOnHover
        classNames={{
          table: styles.table,
          thead: styles['table-head'],
          th: styles['table-th'],
          td: styles['table-td'],
        }}
        withTableBorder={true}
        withColumnBorders={true}
      >
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Name</Table.Th>
            <Table.Th>Is Protected</Table.Th>
            <Table.Th>Is Hided</Table.Th>
            <Table.Th>Is Not Eligible</Table.Th>
            <Table.Th>Tag Color</Table.Th>
            <Table.Th></Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {tags.map((tag) => (
            <TagsTableRow
              key={tag.id}
              tag={tag}
              onMutationSuccess={resetPaginate}
            />
          ))}
        </Table.Tbody>
      </Table>
    </Box>
  )
}

export default TagsListTable
